module.exports = __webpack_public_path__ + "media/40.68b82d96.mp3";